export interface IAgentsNewSearch {
  orchestrationGroupId?: string;
}

/** Lets the Agents page deep-link "add agent" straight into a chosen group. */
export function parseAgentsNewSearch(raw: Record<string, unknown>): IAgentsNewSearch {
  return {
    orchestrationGroupId:
      typeof raw.orchestrationGroupId === 'string' && raw.orchestrationGroupId.trim()
        ? raw.orchestrationGroupId
        : undefined,
  };
}
